/**
 * The job titles a hotel actually hires for, by department.
 *
 * A list rather than free text because "Steward", "steward" and "Stewart" are
 * three different roles to a report and one job to a hotel - and because
 * picking from a list of the department's own roles catches the mismatch of a
 * Steward filed under Housekeeping.
 *
 * It is a starting list, not a closed one: the form keeps a free-text option
 * for anything a particular hotel calls something else.
 */
export const STAFF_DEPARTMENTS = [
    'FRONT_OFFICE',
    'KITCHEN',
    'FNB',
    'HOUSEKEEPING',
    'STORES',
    'ADMIN',
];
export const STAFF_DEPARTMENT_LABELS = {
    FRONT_OFFICE: 'Front Office',
    KITCHEN: 'Kitchen',
    FNB: 'Food & Beverage',
    HOUSEKEEPING: 'Housekeeping',
    STORES: 'Stores',
    ADMIN: 'Admin',
};
export const STAFF_ROLES = {
    FRONT_OFFICE: [
        'Front Office Manager',
        'Duty Manager',
        'Front Desk Executive',
        'Guest Relations Executive',
        'Reservations Executive',
        'Night Auditor',
        'Concierge',
        'Bell Captain',
        'Bellboy',
        'Driver',
    ],
    KITCHEN: [
        'Executive Chef',
        'Head Chef',
        'Sous Chef',
        'Chef de Partie',
        'Line Cook',
        'Commis',
        'Tandoor Chef',
        'Halwai',
        'Baker',
        'Kitchen Steward',
        'Dishwasher',
    ],
    FNB: [
        'Restaurant Manager',
        'Banquet Manager',
        'Captain',
        'Steward',
        'Waiter',
        'Bartender',
        'Barista',
        'Cashier',
        'Room Service Attendant',
        'Kitchen Order Taker',
    ],
    HOUSEKEEPING: [
        'Housekeeping Manager',
        'Housekeeping Supervisor',
        'Room Attendant',
        'Houseman',
        'Laundry Attendant',
        'Linen Room Attendant',
        'Public Area Attendant',
        'Gardener',
    ],
    STORES: [
        'Stores Manager',
        'Storekeeper',
        'Purchase Officer',
        'Purchase Executive',
        'Receiving Clerk',
    ],
    ADMIN: [
        'General Manager',
        'Operations Manager',
        'Accountant',
        'Accounts Executive',
        'HR Executive',
        'IT Support',
        'Security Supervisor',
        'Security',
        'Maintenance Supervisor',
        'Electrician',
        'Plumber',
    ],
};
/** Every role we suggest, for a search or a check that one is known. */
export const ALL_STAFF_ROLES = STAFF_DEPARTMENTS.flatMap((department) => STAFF_ROLES[department]);
/** Which department a job title belongs to, if it is one we suggest. */
export function departmentForRole(role) {
    const wanted = role.trim().toLowerCase();
    for (const department of STAFF_DEPARTMENTS) {
        if (STAFF_ROLES[department].some((known) => known.toLowerCase() === wanted)) {
            return department;
        }
    }
    return null;
}
//# sourceMappingURL=staff.js.map